import { render, staticRenderFns } from "./item_category_select.vue?vue&type=template&id=220b663f&"
import script from "./item_category_select.vue?vue&type=script&lang=js&"
export * from "./item_category_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports